(function (root) {
  'use strict';
  if (!root.document || root.AlvauraCartPageRefresh) return;
  const cart = root.document.querySelector('cart-items-component');
  root.AlvauraCartPageRefresh = true;
  let version = 0, controller = null, queued = false, suspended = false, readTimer;
  const retire = () => {
    const previous = controller;
    controller = null;
    version += 1;
    queued = false;
    clearTimeout(readTimer);
    previous?.abort();
  };
  const updateCounts = (count) => {
    if (!Number.isSafeInteger(count) || count < 0) return;
    const label = (count === 1 ? root.cartStrings?.item : root.cartStrings?.items)?.replace('[count]', count);
    const value = count < 100 ? String(count) : root.cartStrings?.item_99;
    if (value) root.document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = node.closest('.cart-text') ? `(${value})` : value; });
    if (label) {
      root.document.querySelectorAll('[data-cart-text]').forEach((node) => { node.textContent = label; });
      root.document.querySelectorAll('button.cart-icon--drawer, a.cart-icon--drawer').forEach((node) => node.setAttribute('aria-label', label));
    }
  };
  const scheduleRead = () => {
    if (suspended || !cart?.isConnected || !cart.dataset.sectionId) return;
    version += 1;
    queued = true;
    clearTimeout(readTimer);
    if (!controller) readTimer = setTimeout(refresh, 200);
  };
  async function refresh() {
    if (!cart?.isConnected || suspended || controller || typeof cart.updateSections !== 'function') return;
    const owner = controller = new AbortController();
    queued = false;
    const requestVersion = version;
    try {
      const url = new URL(root.location.href);
      url.search = '';
      const preview = new URL(root.location.href).searchParams.get('preview_theme_id');
      if (/^\d+$/.test(preview || '')) url.searchParams.set('preview_theme_id', preview);
      url.searchParams.set('sections', `${cart.dataset.sectionId},cart-icon-bubble`);
      const response = await root.fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: owner.signal, headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const sections = await response.json();
      const html = sections[cart.dataset.sectionId];
      if (typeof html !== 'string') return;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const nextCart = parsed.querySelector('cart-items-component');
      const count = Number(nextCart?.dataset.itemCount);
      if (controller !== owner || !cart.isConnected || suspended || version !== requestVersion || !nextCart?.querySelector('.section--main-cart')
        || !Number.isSafeInteger(count) || count < 0) return;
      const active = cart.contains(document.activeElement) ? document.activeElement : null;
      cart.updateSections({ [cart.dataset.sectionId]: html });
      cart.classList.toggle('is-empty', count === 0);
      root.updateCartEmptyStateVisibility?.(count);
      if (typeof sections['cart-icon-bubble'] === 'string') {
        const header = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        const bubble = header.querySelector('.cart-count-bubble');
        root.document.querySelectorAll('#cart-icon-bubble').forEach((target) => {
          const previous = target.querySelector('.cart-count-bubble');
          if (bubble) previous ? previous.replaceWith(bubble.cloneNode(true)) : target.appendChild(bubble.cloneNode(true));
          else previous?.remove();
        });
      }
      updateCounts(count);
      if (active?.id && !active.isConnected && document.activeElement === document.body) {
        const replacement = document.getElementById(active.id);
        if (replacement && cart.contains(replacement) && replacement.tagName === active.tagName
          && replacement.getAttribute('aria-label') === active.getAttribute('aria-label')) replacement.focus({ preventScroll: true });
      }
    } catch (_) {
    }
    finally {
      if (controller === owner) {
        controller = null;
        if (queued && cart.isConnected && !suspended) readTimer = setTimeout(refresh, 200);
      }
    }
  }
  const mutation = (event) => {
    retire();
    const data = event?.cartData || event?.detail?.data || event?.detail || event;
    if (!suspended && cart?.isConnected) updateCounts(data?.item_count);
    scheduleRead();
  };
  const completed = (entries) => {
    if (suspended || !entries.getEntries().some((entry) => {
      if (!['fetch', 'xmlhttprequest'].includes(entry.initiatorType) || !(entry.responseEnd > 0)) return false;
      try {
        const url = new URL(entry.name, root.location.href);
        return url.origin === new URL(root.location.href).origin && /\/cart\/(add|change|update|clear)(\.js)?$/.test(url.pathname);
      } catch (_) { return false; }
    })) return;
    const drawer = root.document.querySelector('cart-drawer');
    if (cart?.isConnected) {
      mutation();
      if (drawer?.classList.contains('open')) drawer.invalidateCartRead?.();
      else drawer?.retireCartRead?.();
    } else drawer?.invalidateCartRead?.();
  };
  let observer;
  const observe = () => {
    if (typeof root.PerformanceObserver !== 'function') return;
    try {
      observer ||= new root.PerformanceObserver(completed);
      observer.observe({ type: 'resource' });
    } catch (_) { observer?.disconnect(); }
  };
  const events = ['cart:updated', 'DiscountUpdateEvent', 'GiftWrapUpdateEvent'];
  events.forEach((name) => document.addEventListener(name, mutation));
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, mutation);
  root.addEventListener('pagehide', () => {
    suspended = true;
    retire();
    observer?.disconnect();
  });
  root.addEventListener('pageshow', () => { retire(); suspended = false; observe(); scheduleRead(); });
  observe();
  try {
    if (cart && typeof root.customElements?.whenDefined === 'function') {
      root.customElements.whenDefined('cart-items-component').then(scheduleRead).catch(() => {});
    } else if (root.document.readyState === 'complete') scheduleRead();
  } catch (_) {
    if (root.document.readyState === 'complete') scheduleRead();
  }
})(typeof window === 'object' ? window : globalThis);
